import { Component, OnInit } from '@angular/core';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { NewsService } from './news.service';

@Component({
  selector: 'app-all-news',
  templateUrl: './all-news.component.html',
  styleUrls: ['./all-news.component.scss']
})
export class AllNewsComponent implements OnInit {
  allNews = [];

  page: number = 1;
  pageSize: number = 12;
  collectionSize: number;
  rows: any[];

  constructor(
    private newsService: NewsService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.newsService.getAllNews().subscribe(res => {
      // // console.log(res);

      this.allNews = res.result;
      this.refresh();
      this.gobalFunctionService.setSEO('ข่าวสารทั้งหมด', 'website', '');
      // // console.log(this.allNews);
    });
  }


  refresh() {
    this.collectionSize = this.allNews.length;
    this.rows = this.allNews
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

}
